module.exports = __webpack_public_path__ + "static/media/worldmap.f1ec2cf7.png";